export const NOTIFICATIONS_SPINNER = 'NOTIFICATIONS_SPINNER'
export const NOTIFICATIONS_SET_DATA = 'NOTIFICATIONS_SET_DATA'
export const NOTIFICATIONS_SEND_REQUEST = 'NOTIFICATIONS_SEND_REQUEST'
